<div *ngIf="person">
  <mat-toolbar>
    <mat-icon>person</mat-icon> Remedy Profile
  </mat-toolbar>

  {{person|json}}
</div>
